import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import Login from '../common/login';

const cookies = new Cookies();

// حالات الطلب بالنظام
const STATUS = {
    0: 'انتظار', 1: 'مطبوع', 2: 'ملغى',
    3: 'منجَح', 4: 'راجع', 5: 'ما انتصل بيه',
    '-3': 'غير موجود'
};

// أصناف المطابقة — الترتيب هو ترتيب العرض
const KINDS = [
    { key: 'match', label: 'مطابق', tone: 'ok' },
    { key: 'diff', label: 'سعر مختلف', tone: 'warn' },
    { key: 'done', label: 'منجَح سلفاً', tone: 'info' },
    { key: 'blocked', label: 'ملغى أو راجع', tone: 'bad' },
    { key: 'missing', label: 'غير موجود', tone: 'bad' },
    { key: 'dup', label: 'مكرّر بالاكسل', tone: 'warn' },
    { key: 'bad', label: 'صف غير صالح', tone: 'bad' },
];

// حرف العمود مثل الاكسل — A · B · … · AA
const colLetter = (i) => {
    let s = '', n = i;
    do { s = String.fromCharCode(65 + (n % 26)) + s; n = Math.floor(n / 26) - 1; } while (n >= 0);
    return s;
};

// الخانتان المطلوب ربطهما، بالترتيب
const SLOTS = [
    { key: 'id', field: 'idCol', no: '١', label: 'رقم الوصل' },
    { key: 'price', field: 'priceCol', no: '٢', label: 'السعر' },
];

class SuccessOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // الخطوة ١
            fileName: '',
            sheets: [],
            sheetName: '',
            headers: [],
            rows: [],           // مصفوفة مصفوفات (بلا صف الرأس)
            // الخطوة ٢
            idCol: '',
            priceCol: '',
            armed: 'id',      // الخانة المسلّحة — النقر على عمود يملؤها
            stage: 'upload',  // upload ⟵ map ⟵ result
            stripZeros: true,
            // الخطوة ٣
            searching: false,
            result: null,       // { items:[...], counts:{}, totals:{} }
            picked: {},         // id ⟵ true
            filter: 'all',
            applying: false,
            appliedMsg: '',
            lastListId: null
        };
    }

    // ════════════════════════════════════════════════════════════════════
    // الخطوة ١ — قراءة الاكسل
    // ════════════════════════════════════════════════════════════════════

    onFile = (file) => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const wb = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
                const sheets = wb.SheetNames || [];
                if (sheets.length === 0) {
                    toast.error('الملف بلا أوراق', { position: "top-center", autoClose: 4000 });
                    return;
                }
                this._wb = wb;
                this.setState({ fileName: file.name, sheets, result: null, picked: {}, stage: 'map' },
                    () => this.pickSheet(sheets[0]));
            } catch (err) {
                console.log(err);
                toast.error('تعذّرت قراءة الملف — تأكد إنه اكسل سليم', { position: "top-center", autoClose: 5000 });
            }
        };
        reader.onerror = () => toast.error('تعذّرت قراءة الملف', { position: "top-center", autoClose: 4000 });
        reader.readAsArrayBuffer(file);
    }

    pickSheet = (name) => {
        const ws = this._wb && this._wb.Sheets[name];
        if (!ws) return;
        const grid = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: false });
        if (grid.length === 0) {
            this.setState({ sheetName: name, headers: [], rows: [], idCol: '', priceCol: '', result: null });
            return;
        }

        // صف الرأس = أول صف فيه خانتان غير فاضيتين على الأقل
        let headIdx = 0;
        for (let i = 0; i < Math.min(grid.length, 10); i++) {
            const filled = grid[i].filter(c => String(c).trim() !== '').length;
            if (filled >= 2) { headIdx = i; break; }
        }

        const raw = grid[headIdx] || [];
        const width = Math.max.apply(null, grid.slice(headIdx).map(r => r.length).concat([raw.length]));
        const headers = [];
        for (let i = 0; i < width; i++) {
            const t = String(raw[i] === undefined ? '' : raw[i]).trim();
            headers.push({ i, name: t || `عمود ${i + 1}` });
        }

        const rows = grid.slice(headIdx + 1);

        // تخمين العمودين من أسماء الرأس
        const guess = (pats) => {
            for (let i = 0; i < headers.length; i++) {
                const n = headers[i].name;
                for (let j = 0; j < pats.length; j++) if (n.indexOf(pats[j]) >= 0) return String(i);
            }
            return '';
        };

        const gId = guess(['الوصل', 'الوصول', 'رقم الطلب', 'الطلب', 'رقم البوليصة', 'ID', 'Id', 'id']);
        let gPr = guess(['المبلغ', 'السعر', 'البضاعة', 'القيمة', 'Price', 'price', 'Amount']);
        if (gPr !== '' && gPr === gId) gPr = '';

        this.setState({
            sheetName: name, headers, rows, result: null, picked: {},
            idCol: gId, priceCol: gPr,
            armed: gId === '' ? 'id' : (gPr === '' ? 'price' : null)
        });
    }

    // ════════════════════════════════════════════════════════════════════
    // التطبيع والمطابقة
    // ════════════════════════════════════════════════════════════════════

    /** رقم الوصل — أرقام فقط */
    parseId = (raw) => {
        const n = parseInt(String(raw === null || raw === undefined ? '' : raw).replace(/[^0-9]/g, ''), 10);
        return (isFinite(n) && n > 0) ? n : null;
    }

    /**
     * السعر — يشيل الفواصل والرموز، وإذا الجيك بوكس مفعّل يقسم على ١٠٠٠
     * للأرقام الكبيرة فقط. الملف الواحد ممكن يخلط الصيغتين فالقرار لكل صف.
     */
    parsePrice = (raw, strip) => {
        const t = String(raw === null || raw === undefined ? '' : raw)
            .replace(/[\u066C\u060C,\s]/g, '')
            .replace(/[^\d.\-]/g, '');
        let v = Number(t);
        if (t === '' || !isFinite(v)) return { value: null, divided: false };
        let divided = false;
        if (strip && Math.abs(v) >= 1000) { v = v / 1000; divided = true; }
        return { value: Math.round(v * 1000) / 1000, divided };
    }

    search = () => {
        const { rows, idCol, priceCol, stripZeros } = this.state;
        if (idCol === '' || priceCol === '') {
            toast.error('اختر عمود رقم الوصل وعمود السعر', { position: "top-center", autoClose: 4000 });
            return;
        }

        const ic = Number(idCol), pc = Number(priceCol);
        const parsed = [];
        const firstSeen = {};

        rows.forEach((r, ri) => {
            const idRaw = r[ic], prRaw = r[pc];
            if (String(idRaw).trim() === '' && String(prRaw).trim() === '') return;   // صف فاضي

            const id = this.parseId(idRaw);
            const pr = this.parsePrice(prRaw, stripZeros);

            const rec = {
                row: ri + 1, id, idRaw: String(idRaw),
                excelPrice: pr.value, divided: pr.divided, priceRaw: String(prRaw),
                kind: null, order: null
            };

            if (id === null || pr.value === null) {
                rec.kind = 'bad';
            } else if (firstSeen[id] !== undefined) {
                rec.kind = 'dup';
                rec.dupOf = firstSeen[id];
            } else {
                firstSeen[id] = ri + 1;
            }
            parsed.push(rec);
        });

        const ids = parsed.filter(r => r.kind === null).map(r => r.id);
        if (ids.length === 0) {
            toast.error('ما فيه صف صالح بالملف', { position: "top-center", autoClose: 4000 });
            this.setState({ result: this.buildResult(parsed, {}), stage: 'result' });
            return;
        }

        this.setState({ searching: true });
        const header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.post(host + `users/orders/bulk-lookup`, { ids }, { headers: header })
            .then(res => {
                const found = {};
                ((res.data.data && res.data.data.orders) || []).forEach(o => { found[Number(o.id)] = o; });
                this.setState({
                    searching: false, result: this.buildResult(parsed, found),
                    picked: {}, filter: 'all', stage: 'result'
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ searching: false });
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message : 'تعذّر البحث عن الطلبات';
                toast.error(msg, { position: "top-center", autoClose: 5000 });
            });
    }

    buildResult = (parsed, found) => {
        const items = parsed.map(r => {
            if (r.kind) return r;
            const o = found[r.id];
            if (!o) return Object.assign({}, r, { kind: 'missing' });

            const sysPrice = Math.round(Number(o.price) * 1000) / 1000;
            const status = Number(o.status);
            const same = Math.abs(sysPrice - r.excelPrice) < 0.001;

            let kind;
            if (status === 3) kind = 'done';
            else if (status === 2 || status === 4) kind = 'blocked';
            else kind = same ? 'match' : 'diff';

            return Object.assign({}, r, {
                kind, order: o, sysPrice, status,
                delta: Math.round((r.excelPrice - sysPrice) * 1000) / 1000
            });
        });

        const counts = {};
        KINDS.forEach(k => { counts[k.key] = 0; });
        let excelTotal = 0, sysTotal = 0;
        items.forEach(r => {
            counts[r.kind] = (counts[r.kind] || 0) + 1;
            if (r.excelPrice !== null && r.kind !== 'dup' && r.kind !== 'bad') excelTotal += r.excelPrice;
            if (r.sysPrice !== undefined && r.kind !== 'dup') sysTotal += r.sysPrice;
        });

        return {
            items, counts,
            excelTotal: Math.round(excelTotal * 100) / 100,
            sysTotal: Math.round(sysTotal * 100) / 100,
            delta: Math.round((excelTotal - sysTotal) * 100) / 100
        };
    }

    // ════════════════════════════════════════════════════════════════════
    // التأشير والإنجاح
    // ════════════════════════════════════════════════════════════════════

    /** القابل للإنجاح: مطابق أو سعر مختلف فقط */
    selectable = (r) => r.kind === 'match' || r.kind === 'diff';

    togglePick = (r) => {
        if (!this.selectable(r)) return;
        const picked = Object.assign({}, this.state.picked);
        if (picked[r.id]) delete picked[r.id]; else picked[r.id] = true;
        this.setState({ picked });
    }

    pickKind = (kind, on) => {
        const picked = Object.assign({}, this.state.picked);
        this.state.result.items.forEach(r => {
            if (r.kind !== kind || !this.selectable(r)) return;
            if (on) picked[r.id] = true; else delete picked[r.id];
        });
        this.setState({ picked });
    }

    apply = () => {
        const ids = Object.keys(this.state.picked).map(Number);
        if (ids.length === 0) return;

        const diffCount = this.state.result.items
            .filter(r => r.kind === 'diff' && this.state.picked[r.id]).length;

        let msg = `راح تنجّح ${ids.length} طلب.`;
        if (diffCount > 0) msg += `\nمنها ${diffCount} سعرها بالاكسل يختلف عن النظام.`;
        msg += '\nتكمّل؟';
        if (!window.confirm(msg)) return;

        // لقطة لكل طلب — سعر الاكسل وسعر النظام وهل كان مطابقاً
        // ⚠️ الصف المكرّر يحمل نفس الرقم — لو فهرسنا الكل يدهس المطابق.
        //    القابل للتأشير وحده هو مصدر اللقطة.
        const byId = {};
        this.state.result.items.forEach(x => {
            if (x.id !== null && this.selectable(x)) byId[x.id] = x;
        });
        const items = ids.map(id => {
            const x = byId[id] || {};
            return {
                id: id,
                excel_price: x.excelPrice === undefined ? null : x.excelPrice,
                sys_price: x.sysPrice === undefined ? null : x.sysPrice,
                matched: x.kind === 'match'
            };
        });

        this.setState({ applying: true });
        const header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.post(host + `users/success/list`, {
            items: items,
            file_name: this.state.fileName,
            admin_name: (typeof localStorage !== 'undefined' && localStorage.getItem('name')) || ''
        }, { headers: header })
            .then(res => {
                const d = (res.data && res.data.data) || {};
                const m = d.msg || `تم انجاح ${ids.length}`;
                this.setState({ applying: false, appliedMsg: m, lastListId: d.list_id || null });
                toast.success(m, { position: "top-center", autoClose: 6000 });
                this.search();      // إعادة مطابقة كي تنتقل المنجَحة لصنفها
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ applying: false });
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message : 'تعذّر إنجاح الطلبات';
                toast.error(msg, { position: "top-center", autoClose: 6000 });
            });
    }

    // ════════════════════════════════════════════════════════════════════

    // ════════════════════════════════════════════════════════════════════
    // ربط الأعمدة بالنقر — تسلّح خانة ثم تنقر العمود بالشبكة
    // ════════════════════════════════════════════════════════════════════

    armSlot = (key) => this.setState({ armed: key });

    /** أي عمود مربوط بأي خانة */
    slotOf = (i) => {
        const k = String(i);
        if (k !== '' && k === this.state.idCol) return 'id';
        if (k !== '' && k === this.state.priceCol) return 'price';
        return null;
    }

    /**
     * النقر على عمود:
     *   فيه خانة مسلّحة ⟵ النقل لها يفوز، حتى لو العمود مربوط بخانة ثانية
     *                      (إلا إذا كان مربوطاً بنفس الخانة المسلّحة ⟵ يُفكّ)
     *   ما فيه تسليح    ⟵ النقر على مربوط يفكّه ويسلّح خانته
     * والعمود الواحد ما ينربط بخانتين — الربط الجديد يفكّ القديم.
     */
    assignCol = (i) => {
        const k = String(i);
        const s = this.state;

        const owned = this.slotOf(i);
        if (owned && (!s.armed || s.armed === owned)) {
            const patch = { armed: owned, result: null, picked: {} };
            patch[owned === 'id' ? 'idCol' : 'priceCol'] = '';
            this.setState(patch);
            return;
        }

        const slot = s.armed || (s.idCol === '' ? 'id' : (s.priceCol === '' ? 'price' : 'id'));
        let nextId = s.idCol, nextPr = s.priceCol;
        if (slot === 'id') { nextId = k; if (nextPr === k) nextPr = ''; }
        else { nextPr = k; if (nextId === k) nextId = ''; }

        this.setState({
            idCol: nextId, priceCol: nextPr, result: null, picked: {},
            armed: nextId === '' ? 'id' : (nextPr === '' ? 'price' : null)
        });
    }

    resetFile = () => this.setState({
        fileName: '', sheets: [], sheetName: '', headers: [], rows: [],
        idCol: '', priceCol: '', armed: 'id', result: null, picked: {}, stage: 'upload'
    });

    goStage = (stage) => {
        if (stage === 'upload' && !this.state.fileName) return;
        if (stage === 'map' && this.state.headers.length === 0) return;
        if (stage === 'result' && !this.state.result) return;
        this.setState({ stage });
    }


    render() {
        if (!cookies.get("token")) return <Login />;

        const s = this.state;
        const r = s.result;
        const pickedCount = Object.keys(s.picked).length;
        const shown = r ? (s.filter === 'all' ? r.items : r.items.filter(x => x.kind === s.filter)) : [];
        const total = r ? r.items.length : 0;
        const mapped = s.idCol !== '' && s.priceCol !== '';
        const reconciled = r && Math.abs(r.delta) < 0.001;

        const slotName = (key) => {
            const col = key === 'id' ? s.idCol : s.priceCol;
            if (col === '') return null;
            const h = s.headers[Number(col)];
            return { letter: colLetter(Number(col)), name: h ? h.name : '' };
        };

        return (
            <Context.Consumer>{ctx => (
                <div className="sx">
                    <style>{`
.sx { direction:rtl; text-align:right; padding:20px 24px 70px;
  --ink:#16202E; --ink2:#64748B; --line:#E6EBF2; --wash:#F8FAFC;
  --ok:#12734C; --warn:#B4530C; --bad:#C0341D; --info:#2450C8; --pick:#0E7C6B;
  color:var(--ink); font-family:'Segoe UI','Noto Kufi Arabic',Tahoma,sans-serif;
  font-size:14px; line-height:1.5; }
.sx .n { font-variant-numeric: tabular-nums; }
.sx-eyebrow { font-size:11px; font-weight:700; letter-spacing:.12em; color:var(--ink2); }

/* ══ الترويسة ══ */
.sx-top { display:flex; align-items:center; gap:14px; flex-wrap:wrap; margin-bottom:16px; }
.sx-top h2 { margin:0; font-size:22px; font-weight:800; letter-spacing:-.01em; }
.sx-top p { margin:0; font-size:13px; color:var(--ink2); }
.sx-top-act { margin-right:auto; display:flex; align-items:center; gap:9px; }

.sx-in { border:1px solid #CBD5E1; border-radius:8px; padding:7px 11px; font-size:14px;
  background:#fff; color:var(--ink); font-family:inherit; }
.sx-in:focus-visible { outline:2px solid var(--info); outline-offset:1px; }
.sx-btn { border:none; border-radius:8px; padding:9px 18px; font-size:14px; font-weight:700;
  background:var(--ink); color:#fff; cursor:pointer; font-family:inherit; }
.sx-btn:disabled { background:#C3CDDA; cursor:not-allowed; }
.sx-btn.is-go { background:var(--pick); }
.sx-btn.is-ghost { background:none; border:1px solid #CBD5E1; color:var(--ink2); font-weight:600; }
.sx-btn.is-ghost:hover { border-color:#94A3B8; color:var(--ink); }

/* ══ الخطوات ══ */
.sx-steps { display:flex; align-items:center; margin-bottom:16px;
  border:1px solid var(--line); border-radius:12px; background:#fff; overflow:hidden; }
.sx-stp { flex:1 1 0; display:flex; align-items:center; gap:11px; padding:12px 16px;
  background:none; border:none; border-left:1px solid var(--line); cursor:default;
  font-family:inherit; text-align:right; color:var(--ink2); min-width:0; }
.sx-stp:last-child { border-left:none; }
.sx-stp.is-can { cursor:pointer; }
.sx-stp.is-can:hover { background:var(--wash); }
.sx-stp:focus-visible { outline:2px solid var(--info); outline-offset:-2px; }
.sx-stp-no { width:26px; height:26px; border-radius:50%; flex:none; font-size:12px;
  font-weight:800; display:flex; align-items:center; justify-content:center;
  background:#E2E8F0; color:#94A3B8; }
.sx-stp.is-done .sx-stp-no { background:#D6EDE5; color:var(--pick); }
.sx-stp.is-now .sx-stp-no { background:var(--ink); color:#fff; }
.sx-stp-txt { display:flex; flex-direction:column; line-height:1.35; min-width:0; }
.sx-stp-txt b { font-size:13.5px; font-weight:700; color:#94A3B8; }
.sx-stp.is-done .sx-stp-txt b { color:var(--ink2); }
.sx-stp.is-now .sx-stp-txt b { color:var(--ink); }
.sx-stp-txt small { font-size:11.5px; color:#94A3B8; overflow:hidden;
  text-overflow:ellipsis; white-space:nowrap; }

/* ══ ملخّص الربط بمرحلة النتائج ══ */
.sx-recap { display:flex; align-items:center; gap:14px; flex-wrap:wrap;
  border:1px solid var(--line); border-radius:12px; background:#fff;
  padding:10px 16px; margin-bottom:12px; font-size:13px; }
.sx-recap-pill { display:inline-flex; align-items:center; gap:7px;
  background:#F1F8F6; border:1px solid #9ED0C2; border-radius:999px;
  padding:3px 11px; color:var(--ink); }
.sx-recap-pill i { font-style:normal; font-size:10px; font-weight:800;
  color:#fff; background:var(--pick); border-radius:50%;
  width:16px; height:16px; display:flex; align-items:center; justify-content:center; }
.sx-recap-pill b { font-weight:700; }
.sx-recap-side { margin-right:auto; display:flex; align-items:center; gap:10px; }

/* ══ الرفع ══ */
.sx-drop { display:block; border:2px dashed #C3CDDA; border-radius:14px; padding:52px 24px;
  text-align:center; color:var(--ink2); cursor:pointer; background:var(--wash); }
.sx-drop:hover { border-color:var(--pick); background:#F2F9F6; color:var(--ink); }
.sx-drop b { display:block; font-size:17px; font-weight:700; color:var(--ink); margin-bottom:6px; }
.sx-drop small { font-size:12px; letter-spacing:.06em; }

/* ══ شريط الربط ══ */
.sx-map { border:1px solid var(--line); border-radius:12px; background:#fff;
  padding:13px 16px; margin-bottom:12px; }
.sx-map-hint { font-size:12.5px; color:var(--ink2); margin:0 0 10px; }
.sx-slots { display:flex; gap:10px; flex-wrap:wrap; align-items:center; }
.sx-slot { display:flex; align-items:center; gap:9px; border:1px solid #CBD5E1;
  background:#fff; border-radius:10px; padding:7px 13px; cursor:pointer;
  font-family:inherit; font-size:13.5px; color:var(--ink); text-align:right; }
.sx-slot:hover { border-color:#94A3B8; }
.sx-slot.is-armed { border-color:var(--pick); box-shadow:0 0 0 3px rgba(14,124,107,.13); }
.sx-slot.is-set { background:#F1F8F6; border-color:#9ED0C2; }
.sx-slot-no { width:20px; height:20px; border-radius:50%; flex:none; font-size:11px;
  font-weight:800; display:flex; align-items:center; justify-content:center;
  background:#E2E8F0; color:var(--ink2); }
.sx-slot.is-armed .sx-slot-no, .sx-slot.is-set .sx-slot-no { background:var(--pick); color:#fff; }
.sx-slot-txt { display:flex; flex-direction:column; line-height:1.35; }
.sx-slot-txt b { font-size:11px; font-weight:700; letter-spacing:.06em; color:var(--ink2); }
.sx-slot.is-set .sx-slot-txt b { color:var(--pick); }
.sx-slot-val { font-weight:700; }
.sx-slot-val.is-empty { color:#94A3B8; font-weight:400; }
.sx-slot-x { font-size:15px; color:#94A3B8; line-height:1; }

.sx-map-side { margin-right:auto; display:flex; align-items:center; gap:14px; flex-wrap:wrap; }
.sx-check { display:flex; align-items:center; gap:8px; font-size:13px; cursor:pointer;
  margin:0; font-weight:400; }
.sx-check input { width:16px; height:16px; accent-color:var(--pick); cursor:pointer; }

/* ══ الشبكة ══ */
.sx-grid { border:1px solid var(--line); border-radius:12px; overflow:hidden;
  background:#fff; margin-bottom:14px; }
.sx-grid-head { display:flex; align-items:center; gap:10px; padding:9px 14px;
  background:var(--wash); border-bottom:1px solid var(--line); }
.sx-grid-scroll { overflow:auto; max-height:330px; }
.sx-g { border-collapse:separate; border-spacing:0; font-size:13px; white-space:nowrap; width:100%; }
.sx-g th { position:sticky; top:0; z-index:2; background:#fff; padding:0;
  border-bottom:1px solid var(--line); border-left:1px solid #F1F5F9; }
.sx-g th:first-child { border-left:none; }
.sx-col { display:flex; flex-direction:column; gap:1px; align-items:flex-start;
  width:100%; padding:7px 11px; background:none; border:none; cursor:pointer;
  font-family:inherit; text-align:right; border-top:3px solid transparent; }
.sx-col:hover { background:#F4F7FB; }
.sx-col:focus-visible { outline:2px solid var(--info); outline-offset:-2px; }
.sx-col-l { font-size:10px; font-weight:800; letter-spacing:.1em; color:#94A3B8; }
.sx-col-n { font-size:12.5px; font-weight:600; color:var(--ink2); max-width:190px;
  overflow:hidden; text-overflow:ellipsis; }
.sx-col.is-set { border-top-color:var(--pick); background:#F1F8F6; }
.sx-col.is-set .sx-col-l { color:var(--pick); }
.sx-col.is-set .sx-col-n { color:var(--ink); font-weight:700; }
.sx-col-tag { font-size:10px; font-weight:800; color:#fff; background:var(--pick);
  border-radius:999px; padding:1px 7px; margin-top:2px; }
.sx-g td { padding:5px 11px; border-bottom:1px solid #F5F8FB;
  border-left:1px solid #F5F8FB; color:var(--ink2); font-variant-numeric: tabular-nums; }
.sx-g td:first-child { border-left:none; }
.sx-g td.is-set { background:#F7FBF9; color:var(--ink); font-weight:600; }
.sx-g tr:last-child td { border-bottom:none; }

/* ══ شريط الحُكم ══ */
.sx-verdict { background:var(--ink); border-radius:14px; padding:18px 22px 15px;
  margin-bottom:14px; color:#E8EEF6; }
.sx-v-row { display:flex; align-items:flex-end; gap:36px; flex-wrap:wrap; }
.sx-v-main { display:flex; flex-direction:column; }
.sx-v-main span { font-size:11px; font-weight:700; letter-spacing:.11em; color:#8FA3BD; }
.sx-v-main b { font-size:44px; font-weight:800; line-height:1.05; letter-spacing:-.03em;
  font-variant-numeric: tabular-nums; color:#35B37E; }
.sx-v-main b.is-none { color:#5E7292; }
.sx-v-main em { font-style:normal; font-size:13px; color:#A9BBD1; margin-top:2px; }
.sx-v-item { display:flex; flex-direction:column; padding-bottom:5px; }
.sx-v-item span { font-size:11px; font-weight:700; letter-spacing:.11em; color:#8FA3BD; }
.sx-v-item b { font-size:22px; font-weight:800; font-variant-numeric: tabular-nums;
  letter-spacing:-.02em; color:#E8EEF6; }
.sx-v-item b.is-zero { color:#35B37E; }
.sx-v-item b.is-off { color:#E2A03F; }
.sx-v-act { margin-right:auto; display:flex; align-items:center; gap:10px; padding-bottom:4px; }
.sx-v-act .sx-btn.is-ghost { border-color:#33435C; color:#A9BBD1; background:none; }
.sx-v-act .sx-btn.is-ghost:hover { border-color:#4A5E7A; color:#E8EEF6; }

.sx-bar { display:flex; height:8px; border-radius:4px; overflow:hidden;
  margin:15px 0 10px; background:#22344A; }
.sx-seg { height:100%; }
.sx-seg.ok { background:#35B37E; } .sx-seg.warn { background:#D9863C; }
.sx-seg.info { background:#5A82D8; } .sx-seg.bad { background:#CF5647; }

.sx-chips { display:flex; gap:7px; flex-wrap:wrap; }
.sx-chip { display:flex; align-items:center; gap:7px; border:1px solid #33435C;
  background:#1D2A3C; color:#C6D3E3; border-radius:999px; padding:4px 12px;
  font-size:12px; cursor:pointer; font-family:inherit; }
.sx-chip:hover { border-color:#4A5E7A; }
.sx-chip.is-on { background:#E8EEF6; color:var(--ink); border-color:#E8EEF6; font-weight:700; }
.sx-chip b { font-variant-numeric: tabular-nums; }
.sx-chip i { width:8px; height:8px; border-radius:2px; font-style:normal; }
.sx-chip i.ok { background:#35B37E; } .sx-chip i.warn { background:#D9863C; }
.sx-chip i.info { background:#5A82D8; } .sx-chip i.bad { background:#CF5647; }

/* ══ النتائج ══ */
.sx-res { border:1px solid var(--line); border-radius:12px; overflow:hidden; background:#fff; }
.sx-res-head { display:flex; align-items:center; gap:12px; flex-wrap:wrap;
  padding:10px 16px; background:var(--wash); border-bottom:1px solid var(--line); }
.sx-res-act { margin-right:auto; display:flex; align-items:center; gap:9px; }
.sx-scroll { max-height:540px; overflow:auto; }
.sx-t { width:100%; border-collapse:collapse; font-size:13.5px; }
.sx-t th { position:sticky; top:0; background:#fff; z-index:1; text-align:right;
  padding:8px 12px; font-size:11px; font-weight:700; letter-spacing:.05em;
  color:var(--ink2); border-bottom:1px solid var(--line); white-space:nowrap; }
.sx-t td { padding:7px 12px; border-bottom:1px solid #F1F5F9; }
.sx-t td.c { text-align:center; font-variant-numeric: tabular-nums; }
.sx-t tr.is-picked td { background:#F1F8F6; }
.sx-t tr.is-locked td { background:#FCFCFD; color:var(--ink2); }
.sx-t tr.is-row:hover td { background:#F6F9FC; }
.sx-tag { display:inline-block; padding:1px 9px; border-radius:999px;
  font-size:11px; font-weight:700; border:1px solid; white-space:nowrap; }
.sx-tag.ok { color:var(--ok); border-color:#BFE3D2; background:#F1F9F5; }
.sx-tag.warn { color:var(--warn); border-color:#F0D4A8; background:#FFF8EE; }
.sx-tag.info { color:var(--info); border-color:#D3DEF2; background:#F4F7FD; }
.sx-tag.bad { color:var(--bad); border-color:#F3C4BB; background:#FDECE9; }
.sx-delta { font-weight:700; font-variant-numeric: tabular-nums; }
.sx-delta.up { color:var(--ok); } .sx-delta.down { color:var(--bad); }
.sx-div { display:inline-block; margin-right:5px; font-size:10px; color:var(--ink2); }
.sx-empty { padding:38px 16px; text-align:center; color:var(--ink2); font-size:14px; }
.sx-note { margin-top:12px; padding:10px 14px; border-radius:9px; font-size:13px;
  background:#FFF8EE; border:1px solid #F0D4A8; color:#7A4A0B; }
@media (prefers-reduced-motion: no-preference) {
  .sx-slot, .sx-col, .sx-chip { transition: background .15s ease, border-color .15s ease; }
}
                    `}</style>

                    <div className="sx-top">
                        <a className="sx-btn is-ghost" href="/successLists"
                            style={{ textDecoration: 'none' }}>→ كشوفات الإنجاح</a>
                        <h2>كشف إنجاح جديد</h2>
                        <p>طابق كشف شركة التوصيل مع النظام، وأنجِح المطابق</p>
                        {s.fileName && (
                            <div className="sx-top-act">
                                <span className="sx-eyebrow">{s.fileName}</span>
                                {s.sheets.length > 1 && (
                                    <select className="sx-in" value={s.sheetName}
                                        onChange={(e) => this.pickSheet(e.target.value)}>
                                        {s.sheets.map(n => <option key={n} value={n}>{n}</option>)}
                                    </select>
                                )}
                                <button className="sx-btn is-ghost" onClick={this.resetFile}>ملف ثاني</button>
                            </div>
                        )}
                    </div>

                    {/* ══ الخطوات ══ */}
                    {s.fileName && (
                        <div className="sx-steps">
                            {[
                                {
                                    key: 'upload', no: '١', label: 'الملف',
                                    sub: s.fileName || 'ما انرفع بعد',
                                    can: !!s.fileName
                                },
                                {
                                    key: 'map', no: '٢', label: 'الأعمدة',
                                    sub: mapped
                                        ? `${slotName('id').letter} · ${slotName('price').letter}`
                                        : 'اضغط على الأعمدة بالشبكة',
                                    can: s.headers.length > 0
                                },
                                {
                                    key: 'result', no: '٣', label: 'المطابقة',
                                    sub: r ? `${r.counts.match + r.counts.diff} جاهز من ${total}` : 'ما انبحث بعد',
                                    can: !!r
                                },
                            ].map(st => {
                                const order = { upload: 0, map: 1, result: 2 };
                                const done = order[st.key] < order[s.stage];
                                return (
                                    <button key={st.key} type="button"
                                        className={'sx-stp'
                                            + (s.stage === st.key ? ' is-now' : '')
                                            + (done ? ' is-done' : '')
                                            + (st.can ? ' is-can' : '')}
                                        onClick={() => this.goStage(st.key)}
                                        disabled={!st.can}>
                                        <span className="sx-stp-no">{st.no}</span>
                                        <span className="sx-stp-txt">
                                            <b>{st.label}</b>
                                            <small>{st.sub}</small>
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    )}

                    {/* ══ الرفع ══ */}
                    {s.stage === 'upload' && (
                        <label className="sx-drop"
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                                e.preventDefault();
                                this.onFile(e.dataTransfer.files && e.dataTransfer.files[0]);
                            }}>
                            <b>اسحب كشف الشركة هنا أو اضغط للاختيار</b>
                            <small>XLSX · XLS · CSV</small>
                            <input type="file" accept=".xlsx,.xls,.csv" style={{ display: 'none' }}
                                onChange={(e) => this.onFile(e.target.files && e.target.files[0])} />
                        </label>
                    )}

                    {/* ══ الربط + الشبكة ══ */}
                    {s.stage === 'map' && s.headers.length > 0 && (
                        <div>
                            <div className="sx-map">
                                <p className="sx-map-hint">
                                    {s.armed
                                        ? <span>اضغط على العمود اللي يحمل <b>{SLOTS.filter(x => x.key === s.armed)[0].label}</b> بالشبكة تحت.</span>
                                        : <span>الأعمدة مربوطة. اضغط على عمود مربوط لفكّه، أو على خانة لإعادة تحديدها.</span>}
                                </p>

                                <div className="sx-slots">
                                    {SLOTS.map(sl => {
                                        const v = slotName(sl.key);
                                        return (
                                            <button key={sl.key} type="button"
                                                className={'sx-slot' + (s.armed === sl.key ? ' is-armed' : '') + (v ? ' is-set' : '')}
                                                onClick={() => this.armSlot(sl.key)}>
                                                <span className="sx-slot-no">{sl.no}</span>
                                                <span className="sx-slot-txt">
                                                    <b>{sl.label}</b>
                                                    <span className={'sx-slot-val' + (v ? '' : ' is-empty')}>
                                                        {v ? `${v.letter} · ${v.name}` : 'ما انحدد بعد'}
                                                    </span>
                                                </span>
                                                {v && <span className="sx-slot-x" title="اضغط العمود بالشبكة لفكّه">×</span>}
                                            </button>
                                        );
                                    })}

                                    <div className="sx-map-side">
                                        <label className="sx-check">
                                            <input type="checkbox" checked={s.stripZeros}
                                                onChange={(e) => this.setState({ stripZeros: e.target.checked, result: null })} />
                                            الاكسل فيه ٣ أصفار زيادة
                                        </label>
                                        {r && (
                                            <button className="sx-btn is-ghost"
                                                onClick={() => this.goStage('result')}>
                                                رجوع للنتائج
                                            </button>
                                        )}
                                        <button className="sx-btn is-go"
                                            disabled={!mapped || s.searching}
                                            onClick={this.search}>
                                            {s.searching ? 'جاري البحث…' : 'بحث ومطابقة'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="sx-grid">
                                <div className="sx-grid-head">
                                    <span className="sx-eyebrow">{s.sheetName || 'الورقة'}</span>
                                    <span style={{ fontSize: 12, color: '#64748B' }}>
                                        {s.rows.length} صف · {s.headers.length} عمود ·
                                        معاينة أول {Math.min(8, s.rows.length)}
                                    </span>
                                </div>
                                <div className="sx-grid-scroll">
                                    <table className="sx-g">
                                        <thead>
                                            <tr>
                                                {s.headers.map(h => {
                                                    const slot = this.slotOf(h.i);
                                                    const sl = slot ? SLOTS.filter(x => x.key === slot)[0] : null;
                                                    return (
                                                        <th key={h.i}>
                                                            <button type="button"
                                                                className={'sx-col' + (slot ? ' is-set' : '')}
                                                                onClick={() => this.assignCol(h.i)}
                                                                title={slot ? 'اضغط لفكّ الربط' : 'اضغط لربطه'}>
                                                                <span className="sx-col-l">{colLetter(h.i)}</span>
                                                                <span className="sx-col-n">{h.name}</span>
                                                                {sl && <span className="sx-col-tag">{sl.no} {sl.label}</span>}
                                                            </button>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {s.rows.slice(0, 8).map((row, ri) => (
                                                <tr key={ri}>
                                                    {s.headers.map(h => (
                                                        <td key={h.i} className={this.slotOf(h.i) ? 'is-set' : ''}>
                                                            {String(row[h.i] === undefined ? '' : row[h.i])}
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ══ ملخّص الربط ══ */}
                    {s.stage === 'result' && r && (
                        <div className="sx-recap">
                            <span className="sx-eyebrow">{s.sheetName}</span>
                            <span className="sx-recap-pill">
                                <i>١</i> رقم الوصل: <b>{slotName('id') ? `${slotName('id').letter} · ${slotName('id').name}` : '—'}</b>
                            </span>
                            <span className="sx-recap-pill">
                                <i>٢</i> السعر: <b>{slotName('price') ? `${slotName('price').letter} · ${slotName('price').name}` : '—'}</b>
                            </span>
                            <span style={{ color: '#64748B' }}>
                                {s.stripZeros ? 'قسمة ٣ أصفار: مفعّلة' : 'قسمة ٣ أصفار: مطفأة'}
                            </span>
                            <div className="sx-recap-side">
                                <button className="sx-btn is-ghost" onClick={() => this.goStage('map')}>
                                    تعديل الأعمدة
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ══ الحُكم ══ */}
                    {s.stage === 'result' && r && (
                        <div>
                            <div className="sx-verdict">
                                <div className="sx-v-row">
                                    <div className="sx-v-main">
                                        <span>جاهز للإنجاح</span>
                                        <b className={(r.counts.match + r.counts.diff) === 0 ? 'is-none' : ''}>
                                            {r.counts.match + r.counts.diff}
                                        </b>
                                        <em>من {total} صف بالملف</em>
                                    </div>
                                    <div className="sx-v-item">
                                        <span>مجموع الاكسل</span>
                                        <b>{r.excelTotal}</b>
                                    </div>
                                    <div className="sx-v-item">
                                        <span>مجموع النظام</span>
                                        <b>{r.sysTotal}</b>
                                    </div>
                                    <div className="sx-v-item">
                                        <span>الفرق</span>
                                        <b className={reconciled ? 'is-zero' : 'is-off'}>
                                            {r.delta > 0 ? '+' : ''}{r.delta}
                                        </b>
                                    </div>
                                    <div className="sx-v-act">
                                        {r.counts.match > 0 && (
                                            <button className="sx-btn is-ghost"
                                                onClick={() => this.pickKind('match', true)}>
                                                أشّر المطابق ({r.counts.match})
                                            </button>
                                        )}
                                        {pickedCount > 0 && (
                                            <button className="sx-btn is-ghost"
                                                onClick={() => this.setState({ picked: {} })}>مسح التأشير</button>
                                        )}
                                        <button className="sx-btn is-go"
                                            disabled={pickedCount === 0 || s.applying}
                                            onClick={this.apply}>
                                            {s.applying ? 'جاري الإنجاح…' : `إنجاح ${pickedCount} طلب`}
                                        </button>
                                    </div>
                                </div>

                                <div className="sx-bar">
                                    {KINDS.map(k => r.counts[k.key] > 0 && (
                                        <div key={k.key} className={'sx-seg ' + k.tone}
                                            style={{ width: (r.counts[k.key] / total * 100) + '%' }}
                                            title={`${k.label}: ${r.counts[k.key]}`} />
                                    ))}
                                </div>

                                <div className="sx-chips">
                                    <button className={'sx-chip ' + (s.filter === 'all' ? 'is-on' : '')}
                                        onClick={() => this.setState({ filter: 'all' })}>
                                        الكل <b>{total}</b>
                                    </button>
                                    {KINDS.map(k => r.counts[k.key] > 0 && (
                                        <button key={k.key}
                                            className={'sx-chip ' + (s.filter === k.key ? 'is-on' : '')}
                                            onClick={() => this.setState({ filter: k.key })}>
                                            <i className={k.tone} />{k.label} <b>{r.counts[k.key]}</b>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="sx-res">
                                <div className="sx-res-head">
                                    <span className="sx-eyebrow">النتائج</span>
                                    <span style={{ fontSize: 12, color: '#64748B' }}>
                                        {shown.length} معروض · <b className="n">{pickedCount}</b> مؤشَّر
                                    </span>
                                </div>
                                <div className="sx-scroll">
                                    {shown.length === 0 ? (
                                        <div className="sx-empty">ما فيه صفوف بهذا التصنيف</div>
                                    ) : (
                                        <table className="sx-t">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 38 }} />
                                                    <th style={{ width: 52 }} className="c">صف</th>
                                                    <th className="c">رقم الوصل</th>
                                                    <th>الحالة</th>
                                                    <th className="c">سعر الاكسل</th>
                                                    <th className="c">سعر النظام</th>
                                                    <th className="c">الفرق</th>
                                                    <th>الزبون</th>
                                                    <th>العنوان</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {shown.map((x, i) => {
                                                    const kind = KINDS.filter(k => k.key === x.kind)[0] || KINDS[0];
                                                    const can = this.selectable(x);
                                                    const on = !!s.picked[x.id];
                                                    return (
                                                        <tr key={i}
                                                            className={'sx-row ' + (on ? 'is-picked' : (can ? 'is-row' : 'is-locked'))}
                                                            onClick={() => this.togglePick(x)}
                                                            style={{ cursor: can ? 'pointer' : 'default' }}>
                                                            <td className="c">
                                                                {can && (
                                                                    <input type="checkbox" checked={on} readOnly
                                                                        style={{ width: 15, height: 15, accentColor: '#0E7C6B', cursor: 'pointer' }} />
                                                                )}
                                                            </td>
                                                            <td className="c">{x.row}</td>
                                                            <td className="c">{x.id === null ? x.idRaw : x.id}</td>
                                                            <td>
                                                                <span className={'sx-tag ' + kind.tone}>{kind.label}</span>
                                                                {x.kind === 'dup' && <span className="sx-div">مع صف {x.dupOf}</span>}
                                                                {x.kind === 'blocked' && <span className="sx-div">{STATUS[x.status] || x.status}</span>}
                                                            </td>
                                                            <td className="c">
                                                                {x.excelPrice === null ? '—' : x.excelPrice}
                                                                {x.divided && <span className="sx-div" title="انقسم على ١٠٠٠">÷١٠٠٠</span>}
                                                            </td>
                                                            <td className="c">{x.sysPrice === undefined ? '—' : x.sysPrice}</td>
                                                            <td className="c">
                                                                {x.delta === undefined || x.delta === 0 ? '—' : (
                                                                    <span className={'sx-delta ' + (x.delta > 0 ? 'up' : 'down')}>
                                                                        {x.delta > 0 ? '+' : ''}{x.delta}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>{x.order ? x.order.name : '—'}</td>
                                                            <td style={{ fontSize: 12, color: '#64748B' }}>
                                                                {x.order ? `${x.order.government} / ${x.order.city}` : '—'}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>

                            {s.lastListId && (
                                <div className="sx-note" style={{
                                    background: '#F1F8F6', borderColor: '#9ED0C2', color: '#0B5346'
                                }}>
                                    ✅<span style={{ marginRight: 6 }}>
                                        {s.appliedMsg} —
                                        <a href={`/successLists?id=${s.lastListId}`}
                                            style={{ marginRight: 6, fontWeight: 700, color: '#0E7C6B' }}>
                                            افتح الكشف
                                        </a>
                                    </span>
                                </div>
                            )}

                            {r.counts.diff > 0 && (
                                <div className="sx-note">
                                    ⚠️ {r.counts.diff} طلب سعرها بالاكسل يختلف عن النظام. تقدر تؤشّرها وتنجّحها،
                                    بس النظام ما يعدّل السعر — يبقى كما هو بـ <code>order_from.price</code>.
                                </div>
                            )}
                        </div>
                    )}

                    <ToastContainer position="bottom-left" autoClose={5000} rtl={false} />
                </div>
            )}</Context.Consumer>
        );
    }
}

export default SuccessOrders;
